<script lang="ts">
	import '@style/global.scss';
	import '@mux/mux-video';
	import { Footer, Navigation, SubMenu, MobileMenu, SearchOverlay } from '@comp';
	import PageWrapper from '@atoms/PageWrapper.svelte';
	import { Menu, menu } from '@tools/Menu.svelte';
	import { menuContainerInOut } from '$lib/animations/MenuTransitions';
	import Tracking from '@atoms/Tracking.svelte';
	import { page } from '$app/stores';
	import { Tracker } from '@tools/tracking/Tracker.js';
	import { browser } from '$app/environment';
	import { PathUtils } from '@tools';
	import { onMount } from 'svelte';

	let { data, children } = $props();

	let searchResults = $state<any[]>([]);
	let searchQuery = $state<string>('');
	let searchLoading = $state<boolean>(false);

	$effect(() => {
		if (searchQuery.length > 2) {
			menu.search();
		} else if (searchQuery.length === 0 && menu.current === Menu.SEARCH) {
			menu.close();
		}
	});

	$effect(() => {
		const unsub = page.subscribe(() => {
			Tracker.pageView(window.location.pathname);
		});

		return () => {
			unsub();
		};
	});

	onMount(() => {
		if (browser) {
			const open = new window.URLSearchParams(window.location.search).get('open');
			if (open) {
				const foundMenu = data.globals.menus.find((menu) => PathUtils.slugify(menu.title) === open);
				if (foundMenu) {
					menu.click(foundMenu.id);
				}
			}
		}
	});
</script>

<Tracking />

<Navigation menus={data.globals.menus} bind:searchQuery bind:searchResults bind:searchLoading />
<section class="content-container">
	<PageWrapper key={data.pathname}>
		{@render children()}
	</PageWrapper>
</section>
<Footer data={data.globals.footer} />

{#if menu.current}
	<div class="menu" in:menuContainerInOut out:menuContainerInOut>
		{#if menu.isMobile}
			<MobileMenu menus={data.globals.menus} />
		{:else if menu.isSearching}
			<SearchOverlay query={searchQuery} results={searchResults} loading={searchLoading} />
		{:else}
			{#each data.globals.menus as menu}
				<SubMenu data={menu} />
			{/each}
		{/if}
	</div>
{/if}

<style lang="scss">
	.content-container {
		position: relative;
		height: 100%;
		width: 100%;
		display: grid;
		grid-template-columns: auto;
		grid-template-rows: auto;
		align-items: start;
		padding-top: var(--nav-height);
	}

	.menu {
		position: fixed;
		top: var(--nav-height);
		left: 0;
		height: calc(var(--vh) - var(--nav-height));
		overflow-y: auto;
		overscroll-behavior: contain;
		width: 100%;
		background-color: $colorBackground;
		z-index: 20;
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
</style>
